import { makeStyles } from '@material-ui/core/styles'

export const useCarouselSlotStyles = makeStyles({
  carouselSlot: {
    marginRight: 10,
    marginLeft: 10,
    order: ({ order }) => order
  }
})
